import { render, staticRenderFns } from "./ProformaInvoices.vue?vue&type=template&id=2a4ae7c2&scoped=true"
import script from "./ProformaInvoices.vue?vue&type=script&lang=js"
export * from "./ProformaInvoices.vue?vue&type=script&lang=js"
import style0 from "./ProformaInvoices.vue?vue&type=style&index=0&id=2a4ae7c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4ae7c2",
  null
  
)

export default component.exports